const listNamesConfig = {
  entityItemsNamePlural: "POS Sources",
  entityItemName: "POS Source",
  areaAccessName: "Playlists"
};

export default listNamesConfig;